import {
  FluidCustomStyles,
  FluidTheme,
  FluidThemeInterface,
} from '@lmig/fluid-core';
import { Component, ComponentInterface, Element, h, Prop } from '@stencil/core';

import { Utils } from '../../../utils/utils';

/**
 * @displayName Header Actions
 */
@Component({
  tag: 'fluid-header-actions',
  styleUrl: 'fluid-header-actions.less',
  shadow: true,
})
export class FluidHeaderActions
  implements ComponentInterface, FluidThemeInterface
{
  /**
   * What theme settings should the component use?
   * @type {string}
   * @propCategory: Theming
   */
  @Prop({ mutable: true }) theme: FluidTheme = FluidTheme.CORP;

  /**
   * If FluidThemeProvider is used, should this component override the
   * global theme with its local theme?
   */
  @Prop({ mutable: true }) overrideGlobalTheme: boolean;

  /**
   * Get a reference to the host element
   */
  @Element() host: HTMLFluidHeaderActionsElement;

  /**
   * Is the header actions bar visible?
   */
  @Prop({ mutable: true }) active: boolean;

  /**
   * Allows overriding of the defaults (using CSSinJS syntax)
   */
  @Prop({ mutable: true }) customStyles: FluidCustomStyles;

  /**
   * Called every time the component is connected to the DOM.
   * @action: setGlobalTheme - updates theme to match global theme & subscribes to changes
   */
  connectedCallback(): void {
    Utils.setGlobalTheme(this);
  }

  render() {
    if (!this.active) return;
    return (
      <div
        class='header-actions'
        style={this.customStyles as { [key: string]: string }}>
        <slot />
      </div>
    );
  }
}
